import { bool, string, func, oneOfType, number, arrayOf, node } from 'react-proptypes';
import { RoundedButton } from '../buttons';

const RoundedRadioButton = ({
  value,
  name,
  checked,
  children,
  onChangeHandler,
}) => (
  <label>
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChangeHandler}
      css={{opacity: '0', position: 'absolute'}}
    />
    <RoundedButton as='span' active={checked}>
      {children}
    </RoundedButton>
  </label>
);

RoundedRadioButton.defaultProps = {
  checked: false,
};

RoundedRadioButton.propTypes = {
  name: string.isRequired,
  value: oneOfType([string, bool, number]).isRequired,
  children: oneOfType([node, arrayOf(node)]).isRequired,
  onChangeHandler: func.isRequired,
  checked: bool,
};

export default RoundedRadioButton;
